/* NewBorn Times · l'atelier de la section produit de l'accueil, visiteur anglais (25-26/10/2026, remarques d'Emile).
   Au premier prénom tapé dans la section, la création s'ouvre en plein écran : la couverture de la section (celle de Sophie,
   qui se remplit toute seule) y est DÉPLACÉE, entière et grande, et une seule question à la fois s'affiche dessous :
   prénom ; fille ou garçon et couleur ; date ; ville (toutes les villes des États-Unis) ; photo (cadrée au doigt sur la
   couverture, ou « Not now ») ; détails (heure, poids, taille, parents, à passer) ; format. « Continue » envoie les réponses
   et la photo à notre serveur, qui les vérifie et crée le dossier, puis met le magazine au panier (numéro de dossier caché
   « _Dossier ») et ouvre directement la page de paiement (chemin du 24/10/2026, éprouvé jusqu'au paiement).
   Les réponses restent aussi copiées dans le formulaire de Sophie, ce qui fait vivre sa couverture (prénom, date, ville). */
(function () {
  'use strict';
  function installer(root) {
    if (root.dataset.nbtAtelier || root.getAttribute('data-nbt-lang') !== 'en') return;
    var at = root.querySelector('[data-nbt-at]'), form = root.querySelector('[data-nbt-form]'), pv = root.querySelector('[data-nbt-pv]');
    if (!at || !form || !pv) return;
    root.dataset.nbtAtelier = '1';
    var $ = function (s) { return at.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(at.querySelectorAll(s)); };
    var champ = function (s) { return form.querySelector(s); };
    var CALME = window.matchMedia('(prefers-reduced-motion: reduce)');
    var BASE = '/apps/newborn';
    var RACINE = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var ETAPES = ['prenom', 'enfant', 'date', 'ville', 'photo', 'details', 'format'];
    var etape = 0, ouvert = false, envoi = false;
    // photoChoix : '' tant que rien n'est choisi, 'plus_tard' (« I'll add it later »), 'sans' (« No photo ») ; une photo posée vaut 'avec'
    var etat = { ville: null, photo: null, cadrage: [50, 50], photoChoix: '', couleurChoisie: false, heureDouble: '', second: false };
    var zone = $('[data-nbt-at-zone]'), maison = pv.parentNode, apres = pv.nextSibling;
    var msg = $('[data-nbt-at-msg]'), suite = $('[data-nbt-at-suite]'), passer = $('[data-nbt-at-passer]'), retour = $('[data-nbt-at-retour]');
    var fire = function (el, t) { el.dispatchEvent(new Event(t, { bubbles: true })); };
    var mettre = function (el, v) { if (!el) return; el.value = v; fire(el, 'input'); fire(el, 'change'); };
    var cocher = function (el) { if (!el) return; el.checked = true; fire(el, 'change'); };
    var prenom = function () { return $('[data-nbt-at-prenom]').value.trim(); };

    // ------------------------------------------------ la couverture : entière, et la plus grande possible
    function ajuster() {
      if (!ouvert) return;
      var vv = window.visualViewport, H = vv ? vv.height : window.innerHeight, W = vv ? vv.width : window.innerWidth;
      // quand le clavier du téléphone s'ouvre, l'écran utile rapetisse : l'atelier suit, la question reste visible
      at.style.height = Math.round(H) + 'px'; at.style.top = (vv ? Math.round(vv.offsetTop) : 0) + 'px';
      var large = W >= 990, tete = $('.nbt-at__tete').offsetHeight, fiche = $('.nbt-at__fiche').offsetHeight;
      var h = large ? H - tete - 70 : H - tete - fiche - 26;
      var w = large ? Math.min(W * 0.48, 600) : W - 28;
      var l = Math.max(90, Math.min(w, h / 1.4145));
      zone.style.width = Math.round(l) + 'px';
      pv.style.setProperty('width', Math.round(l) + 'px', 'important');
    }
    window.addEventListener('resize', ajuster);
    if (window.visualViewport) { visualViewport.addEventListener('resize', ajuster); visualViewport.addEventListener('scroll', ajuster); }

    function ouvrir(depuis) {
      if (ouvert) return;
      ouvert = true;
      zone.appendChild(pv);
      at.hidden = false;
      document.documentElement.classList.add('nbt-at-ouvert');
      try { history.pushState({ nbtAtelier: true }, ''); } catch (e) { /* */ }
      requestAnimationFrame(function () { at.classList.add('is-on'); ajuster(); });
      // ce qui a déjà été tapé dans la section passe dans l'atelier
      $('[data-nbt-at-prenom]').value = champ('[data-nbt-first]').value;
      var d = champ('[data-nbt-date]'); if (d && d.value) { $('[data-nbt-at-date]').value = d.value; $('[data-nbt-at-date]').dispatchEvent(new Event('nbt-date-remplie')); }
      var v = champ('[data-nbt-city]'); if (v && v.value && !etat.ville) { $('[data-nbt-at-ville]').value = v.value; chercher(v.value.trim()); }
      // on reste sur la question où l'on tapait : la première lettre du prénom ouvre sur le prénom (la personne n'a pas
      // fini de l'écrire), une date ou une ville tapée dans la section ouvre sur la sienne
      aller(Math.max(0, ETAPES.indexOf(depuis || 'prenom')), true);
      setTimeout(function () { var f = at.querySelector('[data-nbt-at-q="' + ETAPES[etape] + '"] input:not(.nbt-dus__source)'); if (f && f.type !== 'file') { f.focus(); try { var n = f.value.length; f.setSelectionRange(n, n); } catch (e) { /* */ } } }, 60);
    }
    function fermer(parHistorique) {
      if (!ouvert) return;
      ouvert = false;
      at.classList.remove('is-on');
      document.documentElement.classList.remove('nbt-at-ouvert');
      pv.style.removeProperty('width');
      maison.insertBefore(pv, apres);
      setTimeout(function () { at.hidden = true; }, CALME.matches ? 0 : 300);
      if (!parHistorique && history.state && history.state.nbtAtelier) { try { history.back(); } catch (e) { /* */ } }
    }
    $('[data-nbt-at-fermer]').addEventListener('click', function () { fermer(false); });
    window.addEventListener('popstate', function () { if (ouvert) fermer(true); });
    at.addEventListener('keydown', function (e) { if (e.key === 'Escape') fermer(false); });
    // la section : la première lettre (ou une date, une ville) ouvre l'atelier ; son bouton aussi
    champ('[data-nbt-first]').addEventListener('input', function (e) { if (e.target.value.trim()) ouvrir('prenom'); });
    // effacer tout le prénom (dans l'atelier, à la première question) referme l'atelier, sans passer par la croix
    // (Emile, 26/10/2026 : « si on efface le prénom, ça annule l'atelier »)
    $('[data-nbt-at-prenom]').addEventListener('input', function (e) { if (!e.target.value.trim() && ETAPES[etape] === 'prenom') { var c = champ('[data-nbt-first]'); fermer(false); setTimeout(function () { if (c) c.focus({ preventScroll: true }); }, 320); } });
    [['[data-nbt-date]', 'date'], ['[data-nbt-city]', 'ville']].forEach(function (x) { var c = champ(x[0]); if (c) c.addEventListener('input', function () { if (c.value && !ouvert) ouvrir(x[1]); }); });
    document.addEventListener('submit', function (e) { if (e.target === form) { e.preventDefault(); e.stopImmediatePropagation(); ouvrir('prenom'); } }, true);

    // ------------------------------------------------ les étapes
    function valide(i) {
      var n = ETAPES[i];
      if (n === 'prenom') return !!prenom() || 'Type their first name.';
      if (n === 'enfant') return !!form.querySelector('[data-nbt-sex]:checked') || 'Choose a girl or a boy.';
      if (n === 'date') { var d = $('[data-nbt-at-date]').value, auj = new Date().toISOString().slice(0, 10); if (!d) return 'Type the date of birth: month, day, year.'; return (d >= '2026-01-01' && d <= auj) || 'The date of birth must be between January 1, 2026 and today.'; }
      if (n === 'ville') return !!etat.ville || 'Choose the city from the list.';
      if (n === 'photo') return !!etat.photo || !!etat.photoChoix || 'Add a photo, or choose “I’ll add it later”.';
      if (n === 'details') return details().erreur || true;
      return true;
    }
    function aller(i, sansAnim) {
      etape = Math.max(0, Math.min(ETAPES.length - 1, i));
      var n = ETAPES[etape];
      $$('[data-nbt-at-q]').forEach(function (q) { q.hidden = q.getAttribute('data-nbt-at-q') !== n; });
      $('[data-nbt-at-progres]').style.width = ((etape + 1) / ETAPES.length * 100) + '%';
      retour.hidden = etape === 0;
      passer.hidden = n !== 'details';
      suite.hidden = n === 'photo' && !etat.photo;
      $('[data-nbt-at-photo-retirer]').hidden = !(n === 'photo' && etat.photo);
      $('[data-nbt-at-photo-choix]').classList.toggle('has-photo', !!etat.photo);
      suite.textContent = n === 'format' ? 'Continue' : 'Next';
      msg.textContent = '';
      $('[data-nbt-at-titre-enfant]').textContent = prenom() ? 'Is ' + prenom() + ' a girl or a boy?' : 'A girl or a boy?';
      if (n === 'format') remplirFormats();
      zone.classList.toggle('is-cadrage', n === 'photo' && !!etat.photo);
      var q = at.querySelector('[data-nbt-at-q="' + n + '"]');
      if (!sansAnim && !CALME.matches && q.animate) q.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], { duration: 260, easing: 'cubic-bezier(.2,.8,.2,1)' });
      ajuster();
      var f = q.querySelector('input:not([type="file"]):not(.nbt-dus__source), button');
      if (f && !sansAnim) setTimeout(function () { f.focus({ preventScroll: true }); }, 30);
    }
    retour.addEventListener('click', function () { aller(etape - 1); });
    suite.addEventListener('click', function () {
      var v = valide(etape);
      if (v !== true) { msg.textContent = v; ajuster(); return; }
      if (ETAPES[etape] === 'format') return payer();
      aller(etape + 1);
    });
    passer.addEventListener('click', function () {
      // passer les détails : rien n'est gardé, tout se complète après le paiement
      ['[data-nbt-at-heure]', '[data-nbt-at-lb]', '[data-nbt-at-oz]', '[data-nbt-at-in]', '[data-nbt-at-parents]'].forEach(function (s) { $(s).value = ''; });
      etat.heureDouble = ''; $('[data-nbt-at-double]').hidden = true;
      aller(etape + 1);
    });
    at.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || e.target.matches('[data-nbt-at-ville]') || e.target.tagName === 'BUTTON' || e.target.tagName === 'LABEL') return;
      e.preventDefault(); suite.click();
    });

    // prénom
    $('[data-nbt-at-prenom]').addEventListener('input', function (e) { mettre(champ('[data-nbt-first]'), e.target.value); });
    // fille ou garçon, et la couleur (elle suit le sexe tant qu'on ne l'a pas choisie)
    function teinte(idx) {
      cocher(form.querySelector('input[name="nbt-edition"][data-idx="' + idx + '"]'));
      $$('[data-nbt-at-ed]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-nbt-at-ed') === String(idx)); });
    }
    $$('[data-nbt-at-sexe]').forEach(function (b) {
      b.addEventListener('click', function () {
        var s = b.getAttribute('data-nbt-at-sexe');
        cocher(form.querySelector('[data-nbt-sex][data-sex="' + s + '"]'));
        $$('[data-nbt-at-sexe]').forEach(function (x) { x.classList.toggle('is-on', x === b); });
        if (!etat.couleurChoisie) teinte(s === 'boy' ? 1 : 0);
        msg.textContent = '';
      });
    });
    $$('[data-nbt-at-ed]').forEach(function (b) { b.addEventListener('click', function () { etat.couleurChoisie = true; teinte(b.getAttribute('data-nbt-at-ed')); }); });
    // les trois couvertures de la section au repos (ordinateur) : elles cochent l'édition de Sophie, et suivent son choix
    var minis = root.querySelectorAll('[data-nbt-ed-mini]');
    function suivreEdition() {
      var r = form.querySelector('input[name="nbt-edition"]:checked'), i = r ? r.getAttribute('data-idx') : '0';
      Array.prototype.forEach.call(minis, function (m) { var on = m.getAttribute('data-nbt-ed-mini') === i; m.classList.toggle('is-on', on); m.setAttribute('aria-checked', String(on)); });
      $$('[data-nbt-at-ed]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-nbt-at-ed') === i); });
    }
    Array.prototype.forEach.call(minis, function (m) { m.addEventListener('click', function () { etat.couleurChoisie = true; teinte(m.getAttribute('data-nbt-ed-mini')); suivreEdition(); }); });
    // une pastille de Sophie (téléphone) choisie avant l'atelier compte aussi comme un choix de couleur
    Array.prototype.forEach.call(form.querySelectorAll('input[name="nbt-edition"]'), function (r) { r.addEventListener('change', function (e) { if (e.isTrusted) etat.couleurChoisie = true; suivreEdition(); }); });
    suivreEdition();
    // date
    var dAt = $('[data-nbt-at-date]');
    dAt.max = new Date().toISOString().slice(0, 10); dAt.min = '2026-01-01';
    ['input', 'change'].forEach(function (t) { dAt.addEventListener(t, function () { mettre(champ('[data-nbt-date]'), dAt.value); }); });

    // ------------------------------------------------ ville : toutes les villes des États-Unis (recherche du serveur)
    var vIn = $('[data-nbt-at-ville]'), vListe = $('[data-nbt-at-villes]'), minuterie = null, derniere = '', relance = '';
    function montrer(villes) {
      vListe.innerHTML = '';
      villes.forEach(function (v, i) {
        var li = document.createElement('li'); li.setAttribute('role', 'option'); li.id = 'nbt-at-v-' + i;
        li.textContent = v.nom + (v.region ? ', ' + v.region : '');
        li.addEventListener('mousedown', function (e) { e.preventDefault(); });
        li.addEventListener('click', function () { choisir(v); });
        vListe.appendChild(li);
      });
      vListe.hidden = !villes.length; vIn.setAttribute('aria-expanded', String(!!villes.length));
      ajuster();
    }
    function choisir(v) {
      etat.ville = v; vIn.value = v.nom + (v.region ? ', ' + v.region : '');
      vListe.hidden = true; vIn.setAttribute('aria-expanded', 'false');
      var c = champ('[data-nbt-city]'); if (c) { mettre(c, v.nom); c.setCustomValidity(''); }
      msg.textContent = ''; ajuster();
    }
    function chercher(q) {
      clearTimeout(minuterie);
      // la liste d'une recherche précédente ne reste jamais affichée pendant qu'on tape : sinon, si la recherche suivante
      // échoue (la boutique freine les requêtes trop rapprochées), on pouvait choisir « Boston » en ayant tapé « Boise »
      // (constaté le 26/10/2026 sur le site public)
      montrer([]);
      if (q.length < 2) return;
      minuterie = setTimeout(function () {
        derniere = q;
        fetch(BASE + '/villes?langue=en&q=' + encodeURIComponent(q)).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function (d) { if (derniere === q) { msg.textContent = ''; montrer((d && d.villes) || []); } })
          .catch(function () { if (derniere !== q) return; montrer([]); msg.textContent = 'The city search is busy. Please try again in a moment.';
            // un seul nouvel essai par texte tapé, un peu plus tard (jamais une boucle si le serveur reste indisponible)
            if (relance !== q) { relance = q; setTimeout(function () { if (derniere === q && vIn.value.trim() === q && !etat.ville) chercher(q); }, 1500); } });
      }, 220);
    }
    vIn.addEventListener('input', function () { etat.ville = null; chercher(vIn.value.trim()); });
    vIn.addEventListener('keydown', function (e) {
      var items = vListe.querySelectorAll('li');
      if (!items.length || vListe.hidden) { if (e.key === 'Enter') { e.preventDefault(); suite.click(); } return; }
      var i = Array.prototype.indexOf.call(items, vListe.querySelector('.is-on'));
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); i = e.key === 'ArrowDown' ? Math.min(items.length - 1, i + 1) : Math.max(0, i - 1); Array.prototype.forEach.call(items, function (x, k) { x.classList.toggle('is-on', k === i); }); vIn.setAttribute('aria-activedescendant', items[i].id); }
      if (e.key === 'Enter') { e.preventDefault(); items[Math.max(0, i)].click(); }
    });

    // ------------------------------------------------ photo : posée sur la couverture, cadrée au doigt, jugée tout de suite
    var boite = pv.querySelector('[data-nbt-pv-photo]'), image = pv.querySelector('[data-nbt-pv-photo-img]');
    var etatPhoto = $('[data-nbt-at-photo-etat]');
    // la phrase sous les trois choix : rassurer d'abord (la cigogne reste si on n'en met pas), puis guider (cadrer)
    var NOTE_CIGOGNE = 'No photo? The cover keeps the stork.';
    function note(t) { etatPhoto.textContent = t || NOTE_CIGOGNE; etatPhoto.hidden = false; ajuster(); }
    // la photo dans le cadre de la couverture ; la fonction de Sophie (updatePreview) la cacherait à chaque saisie :
    // elle est reposée après chacune
    function poserPhoto() {
      if (!boite || !image) return;
      var on = !!etat.photo;
      boite.classList.toggle('is-on', on);
      image.hidden = !on;
      if (on) { if (image.src !== etat.photo.url) image.src = etat.photo.url; image.style.objectPosition = etat.cadrage[0] + '% ' + etat.cadrage[1] + '%'; }
      var later = pv.querySelector('[data-nbt-pv-later]'); if (later) later.hidden = true;
      var lib = $('[data-nbt-at-photo-libelle]'); if (lib) lib.textContent = on ? 'Change photo' : 'Add a photo';
    }
    ['input', 'change'].forEach(function (t) { form.addEventListener(t, function () { setTimeout(poserPhoto, 0); }); });
    window.addEventListener('resize', function () { setTimeout(poserPhoto, 0); });
    function lireImage(blob) {
      var essai = function (o) { return createImageBitmap(blob, o); };
      return essai({ imageOrientation: 'from-image' }).catch(function () { return essai(); }).catch(function () {
        return new Promise(function (ok, ko) { var u = URL.createObjectURL(blob), im = new Image(); im.onload = function () { ok(im); }; im.onerror = function () { ko(new Error('image')); }; im.src = u; });
      });
    }
    // le cadre de la couverture (largeur / hauteur) et la photo recadrée telle qu'elle partira, en JPEG
    function rapport() { var r = boite.getBoundingClientRect(); return r.width && r.height ? r.width / r.height : 1.1; }
    function recadrer() {
      var b = etat.photo.bmp, W = b.width, H = b.height, a = rapport();
      var sw = Math.min(W, H * a), sh = sw / a;
      var sx = (W - sw) * etat.cadrage[0] / 100, sy = (H - sh) * etat.cadrage[1] / 100;
      var k = Math.min(1, 3000 / Math.max(sw, sh));
      return { b: b, sx: sx, sy: sy, sw: sw, sh: sh, w: Math.round(sw * k), h: Math.round(sh * k) };
    }
    // netteté au cadre le plus haut de la couverture imprimée (126 x 136,4 mm), comme le serveur (validation.mjs, D-0219)
    function dpi() { var c = recadrer(); return 25.4 / Math.max(126 / c.w, 136.4 / c.h); }
    function photoJpeg() {
      if (!etat.photo) return Promise.resolve(null);
      var c = recadrer(), cv = document.createElement('canvas'); cv.width = c.w; cv.height = c.h;
      cv.getContext('2d').drawImage(c.b, c.sx, c.sy, c.sw, c.sh, 0, 0, c.w, c.h);
      return new Promise(function (ok, ko) { cv.toBlob(function (x) { x ? ok(x) : ko(new Error('photo')); }, 'image/jpeg', 0.9); });
    }
    $('[data-nbt-at-photo]').addEventListener('change', function (e) {
      var f = e.target.files && e.target.files[0]; e.target.value = '';
      if (!f) return;
      var heic = /heic|heif/i.test(f.type) || /\.hei[cf]$/i.test(f.name);
      note('Preparing your photo…'); pv.classList.add('is-developpe');
      var source = Promise.resolve(f);
      if (heic) { var c = new FormData(); c.append('photo', f, f.name); source = fetch(BASE + '/convertir-photo', { method: 'POST', body: c }).then(function (r) { if (!r.ok) throw new Error('conversion'); return r.blob(); }); }
      source.then(function (src) { return lireImage(src).then(function (bmp) { return { src: src, bmp: bmp }; }); }).then(function (x) {
        if (etat.photo && etat.photo.url) URL.revokeObjectURL(etat.photo.url);
        etat.photo = { bmp: x.bmp, url: URL.createObjectURL(x.src) }; etat.cadrage = [50, 40]; etat.photoChoix = '';
        pv.classList.remove('is-developpe'); poserPhoto();
        if (image && !CALME.matches) { image.classList.remove('is-revele'); void image.offsetWidth; image.classList.add('is-revele'); }
        // netteté au cadre : 150 dpi minimum depuis le 26/10/2026 (Emile : « on descend le minimum [...] et puis on met un
        // petit message ») ; entre 150 et 225, la photo est gardée avec un mot doux ; sous 150, une autre photo ou plus tard
        if (dpi() < 150) {
          URL.revokeObjectURL(etat.photo.url); etat.photo = null; poserPhoto();
          note('This photo is too small for the cover. Choose the original from your phone, or add it later.');
        } else if (dpi() < 225) note('Drag to frame it. This photo is a little small, so the cover will be slightly less sharp. The original from your phone looks best.');
        else note('Drag the photo to frame it.');
        aller(etape, true);
      }).catch(function () { pv.classList.remove('is-developpe'); note('This photo cannot be read. Try another one.'); });
    });
    // « I'll add it later » (redemandée par e-mail et dans l'espace client) ou « No photo » (la cigogne, jamais réclamée)
    function sansPhoto(choix) {
      if (etat.photo && etat.photo.url) URL.revokeObjectURL(etat.photo.url);
      etat.photo = null; etat.photoChoix = choix; poserPhoto(); note('');
      $$('[data-nbt-at-photo-tard], [data-nbt-at-photo-sans]').forEach(function (b) { b.classList.remove('is-on'); });
      $(choix === 'sans' ? '[data-nbt-at-photo-sans]' : '[data-nbt-at-photo-tard]').classList.add('is-on');
      aller(etape + 1);
    }
    $('[data-nbt-at-photo-tard]').addEventListener('click', function () { sansPhoto('plus_tard'); });
    $('[data-nbt-at-photo-sans]').addEventListener('click', function () { sansPhoto('sans'); });
    // retirer la photo posée : on revient aux trois choix, sans rien choisir à sa place
    $('[data-nbt-at-photo-retirer]').addEventListener('click', function () {
      if (etat.photo && etat.photo.url) URL.revokeObjectURL(etat.photo.url);
      etat.photo = null; etat.photoChoix = ''; poserPhoto(); note('');
      aller(etape, true);
    });
    // cadrage au doigt (ou à la souris) sur la couverture
    var glisse = null;
    zone.addEventListener('pointerdown', function (e) {
      if (!etat.photo || ETAPES[etape] !== 'photo') return;
      var r = boite.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) return;
      var b = etat.photo.bmp, s = Math.max(r.width / b.width, r.height / b.height);
      glisse = { x: e.clientX, y: e.clientY, c: etat.cadrage.slice(), dx: b.width * s - r.width, dy: b.height * s - r.height };
      zone.setPointerCapture(e.pointerId); e.preventDefault();
    });
    zone.addEventListener('pointermove', function (e) {
      if (!glisse) return;
      var cl = function (v) { return Math.max(0, Math.min(100, v)); };
      etat.cadrage = [glisse.dx > 0.5 ? cl(glisse.c[0] - (e.clientX - glisse.x) / glisse.dx * 100) : 50, glisse.dy > 0.5 ? cl(glisse.c[1] - (e.clientY - glisse.y) / glisse.dy * 100) : 50];
      poserPhoto();
    });
    ['pointerup', 'pointercancel'].forEach(function (t) { zone.addEventListener(t, function () { glisse = null; }); });

    // ------------------------------------------------ détails : heure, poids, taille, parents (unités américaines)
    function details() {
      var heure = $('[data-nbt-at-heure]').value, lb = $('[data-nbt-at-lb]').value, oz = $('[data-nbt-at-oz]').value, pouces = $('[data-nbt-at-in]').value;
      var r = { heure: heure || '', parents: $('[data-nbt-at-parents]').value.trim() };
      if (lb !== '' || oz !== '') {
        var g = Math.round(((Number(lb) || 0) * 16 + (Number(oz) || 0)) * 28.349523125);
        if (!(Number(oz || 0) >= 0 && Number(oz || 0) < 16) || g < 300 || g > 7000) return { erreur: 'Please check the weight: between 11 oz and 15 lb 7 oz.' };
        r.poids = g;
      }
      if (pouces !== '') {
        var cm = Math.round(Number(pouces) * 2.54 * 2) / 2;
        if (!(cm >= 25 && cm <= 65)) return { erreur: 'Please check the length: between 10 and 25½ in.' };
        r.taille = cm;
      }
      if (etat.heureDouble && heure) r.heure_double = etat.heureDouble;
      return r;
    }
    $('[data-nbt-at-heure]').addEventListener('input', function () { etat.heureDouble = ''; $('[data-nbt-at-double]').hidden = true; });
    $$('[data-nbt-at-dbl]').forEach(function (b) { b.addEventListener('click', function () { etat.heureDouble = b.getAttribute('data-nbt-at-dbl'); $$('[data-nbt-at-dbl]').forEach(function (x) { x.classList.toggle('is-on', x === b); }); msg.textContent = ''; }); });

    // ------------------------------------------------ format, en fin de parcours : les deux choix de Sophie, avec leurs prix,
    // une icône dans un rond de couleur (magazine imprimé, PDF sur téléphone), et le second exemplaire pour l'imprimé
    var ICONE = {
      papier: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" aria-hidden="true"><path d="M6 3h11l2 2v16H6z"/><path d="M4 5v16h13"/><path d="M9 7h7M9 10h7M9 13h4"/></svg>',
      pdf: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" aria-hidden="true"><rect x="7" y="2.5" width="10" height="19" rx="2"/><path d="M10.5 18.5h3"/><path d="M9.5 6h5v6h-5z"/></svg>'
    };
    // les variantes de Sophie : format / édition / supplément (« None », « 2nd copy », ...) ; le second exemplaire change de variante
    var VARIANTES = []; try { VARIANTES = JSON.parse(root.querySelector('[data-nbt-variants]').textContent); } catch (e) { /* */ }
    var EXTRAS = []; try { EXTRAS = JSON.parse(root.querySelector('[data-nbt-ex]').textContent) || []; } catch (e) { /* */ }
    var AUCUN = EXTRAS[0] || 'None', DEUX = EXTRAS[1] || '2nd copy';
    var estPapier = function (f) { return !/^pdf/i.test(String(f || '')); };
    function formatChoisi() { var r = form.querySelector('input[name="nbt-format"]:checked'); return r ? r.value : ''; }
    function editionChoisie() { var r = form.querySelector('input[name="nbt-edition"]:checked'); return r ? r.value : ''; }
    function variante(second) {
      var f = formatChoisi(), ed = editionChoisie(), x = second && estPapier(f) ? DEUX : AUCUN;
      return VARIANTES.filter(function (v) { return v.option1 === f && v.option2 === ed && (!v.option3 || v.option3 === x); })[0] || null;
    }
    function argent(cents) {
      var p = form.querySelector('.nbt-formats .nbt-price'), t = p ? p.textContent.trim() : '';
      var euro = /€/.test(t), virgule = /\d,\d\d/.test(t), n = (cents / 100).toFixed(2);
      if (virgule) n = n.replace('.', ',');
      return euro ? (/^€/.test(t) ? '€' + n : n + ' €') : '$' + n;
    }
    // des raisons de prendre un second exemplaire, qui changent à chaque visite (Emile : « donner les idées à l'acheteur »)
    var RAISONS = ['For the grandparents', 'One to read, one to keep for their 18th', 'For the godparents', 'For family far away'];
    function remplirFormats() {
      var cible = $('[data-nbt-at-formats]'); cible.innerHTML = '';
      Array.prototype.forEach.call(form.querySelectorAll('input[name="nbt-format"]'), function (r, i) {
        var lab = r.closest('label'), b = document.createElement('button'), papier = estPapier(r.value);
        b.type = 'button'; b.className = 'nbt-at__format' + (r.checked ? ' is-on' : '');
        b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', String(r.checked));
        b.innerHTML = '<span class="nbt-at__rond" style="background:' + (papier ? '#F2D3DB' : '#DDE6F5') + '">' + (papier ? ICONE.papier : ICONE.pdf) + '</span><span class="nbt-at__format-t"><span></span><small></small></span><b></b>';
        b.querySelector('.nbt-at__format-t span').textContent = r.value;
        b.querySelector('small').textContent = papier ? 'Mailed to you, plus the PDF' : 'To print or share';
        b.lastChild.textContent = ((lab && lab.querySelector('.nbt-price')) || {}).textContent || '';
        b.addEventListener('click', function () { cocher(r); remplirFormats(); });
        cible.appendChild(b);
      });
      // second exemplaire : seulement pour l'imprimé, et seulement si la boutique a la variante ; jamais coché d'office
      var boite = $('[data-nbt-at-second]'), un = variante(false), deux = variante(true);
      var possible = estPapier(formatChoisi()) && un && deux && deux.id !== un.id;
      boite.hidden = !possible;
      if (!possible) { etat.second = false; $('[data-nbt-at-second-case]').checked = false; return; }
      $('[data-nbt-at-second-case]').checked = etat.second;
      boite.classList.toggle('is-on', etat.second);
      $('[data-nbt-at-second-prix]').textContent = '+' + argent(deux.price - un.price);
      $('[data-nbt-at-second-raison]').textContent = RAISONS[Math.floor(Date.now() / 86400000) % RAISONS.length];
      var couv = pv.querySelector('[data-nbt-pv-cover]'), src = couv ? couv.getAttribute('src') : '';
      $$('[data-nbt-at-second-couv]').forEach(function (i) { i.style.backgroundImage = src ? 'url("' + src + '")' : ''; });
    }
    $('[data-nbt-at-second-case]').addEventListener('change', function (e) { etat.second = e.target.checked; $('[data-nbt-at-second]').classList.toggle('is-on', etat.second); });

    // ------------------------------------------------ paiement : dossier (vérifié par le serveur), panier, page de paiement
    var ETAPE_DU_CHAMP = { prenom: 'prenom', prenom_confirme: 'prenom', accord: 'enfant', date: 'date', ville: 'ville', photo: 'photo', heure: 'details', heure_double: 'details', poids: 'details', taille: 'details', parents: 'details' };
    var TEXTE_DU_CHAMP = { prenom: 'Please check the first name.', prenom_confirme: 'Please check the first name.', accord: 'Choose a girl or a boy.', date: 'Please check the date of birth.', ville: 'Choose the city from the list.' };
    function dateLisible(iso) { var p = iso.split('-'), m = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']; return m[+p[1] - 1] + ' ' + (+p[2]) + ', ' + p[0]; }
    function payer() {
      if (envoi) return;
      envoi = true;
      suite.disabled = true; retour.disabled = true; suite.setAttribute('aria-busy', 'true'); suite.textContent = 'One moment…'; msg.textContent = '';
      var v = etat.ville, d = details(), sexe = (form.querySelector('[data-nbt-sex]:checked') || {}).getAttribute('data-sex');
      var ed = form.querySelector('input[name="nbt-edition"]:checked'), idx = ed ? +ed.getAttribute('data-idx') : 0;
      var reponses = { prenom: prenom(), prenom_confirme: true, accord: sexe === 'boy' ? 'masculin' : 'feminin', date: $('[data-nbt-at-date]').value,
        ville: { nom: v.nom, region: v.region || '', pays: v.pays || 'United States', code_pays: v.code_pays || 'US', lat: v.lat, lon: v.lon, fuseau: v.fuseau || '' },
        edition: ['fille', 'garcon', 'neutre'][idx] || 'fille', langue: 'en', parcours: 'complet', cadrage: '50% 50%',
        photo_choix: etat.photo ? 'avec' : (etat.photoChoix || 'plus_tard'), heure: d.heure || undefined, heure_double: d.heure_double, poids: d.poids, taille: d.taille, parents: d.parents || undefined };
      // la variante : format et édition choisis, avec ou sans second exemplaire (celle de Sophie en repli)
      var v2 = variante(etat.second), idVariante = v2 ? v2.id : (champ('[data-nbt-variant-id]') || {}).value;
      photoJpeg().then(function (photo) {
        var c = new FormData(); c.append('reponses', JSON.stringify(reponses));
        if (photo) c.append('photo', photo, 'photo.jpg');
        return fetch(BASE + '/dossier', { method: 'POST', body: c });
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (rep) {
          if (!r.ok || !rep.numero) { var e = new Error('dossier'); e.rep = rep; throw e; }
          var props = { 'First name': reponses.prenom, 'Born': dateLisible(reponses.date) + ', ' + v.nom, _Dossier: rep.numero };
          // revenu de la page de paiement et « Continue » à nouveau : la ligne d'avant est retirée, jamais deux magazines
          var avant = null; try { avant = sessionStorage.getItem('nbt-at-ligne'); } catch (e) { /* */ }
          var retirer = avant ? fetch(RACINE + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: avant, quantity: 0 }) }).catch(function () { /* déjà partie */ }) : Promise.resolve();
          return retirer.then(function () {
            return fetch(RACINE + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(idVariante), quantity: 1, properties: props }] }) });
          });
        });
      }).then(function (a) {
        if (!a.ok) throw new Error('panier');
        return a.json().catch(function () { return {}; });
      }).then(function (ajout) {
        var cle = ajout && ajout.items && ajout.items[0] && ajout.items[0].key;
        try { if (cle) sessionStorage.setItem('nbt-at-ligne', cle); } catch (e) { /* */ }
        root.__atelierPaiement = true;
        window.location.assign('/checkout');
      }).catch(function (e) {
        envoi = false; suite.disabled = false; retour.disabled = false; suite.removeAttribute('aria-busy'); suite.textContent = 'Continue';
        var err = e && e.rep && e.rep.erreurs;
        var champs = err ? Object.keys(err) : [];
        if (champs.length) {
          var k = champs[0], cible = ETAPE_DU_CHAMP[k];
          if (cible) aller(ETAPES.indexOf(cible), true);
          if (k === 'heure_double') { $('[data-nbt-at-double]').hidden = false; msg.textContent = 'That time happened twice that night (clocks went back). Which one was it?'; }
          else msg.textContent = TEXTE_DU_CHAMP[k] || err[k];
        } else msg.textContent = (e && e.rep && e.rep.message) || 'Something went wrong. Please try again.';
        ajuster();
      });
    }
    window.addEventListener('pageshow', function () { envoi = false; suite.disabled = false; retour.disabled = false; suite.removeAttribute('aria-busy'); if (ouvert) aller(etape, true); });
    // pour l'essai navigateur (essais/essai-atelier.cjs)
    root.__atelier = { get etape() { return ETAPES[etape]; }, get ouvert() { return ouvert; }, get cadrage() { return etat.cadrage.slice(); }, dpi: function () { return etat.photo ? dpi() : null; },
      get photoChoix() { return etat.photo ? 'avec' : etat.photoChoix; }, variante: function () { var v = variante(etat.second); return v && { id: v.id, titre: [v.option1, v.option2, v.option3].join(' / '), prix: v.price }; } };
  }
  function lancer() { document.querySelectorAll('[data-nbt-product]').forEach(installer); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lancer); else lancer();
  document.addEventListener('shopify:section:load', lancer);
})();
